<template>
    <button
        @click="onClick"
        :aria-label="helpText"
        :title="helpText"
        class="close hec-close"
    >
        <fa-icon icon="times"></fa-icon>
    </button>
</template>

<script>
export default {
    name: "HecCloseButton",
    props: {
        helpText: {
            type: String,
            default: null
        }
    },
    methods: {
        onClick() {
            this.$emit("closeClick");
        }
    }
};
</script>

<style lang="scss">
.hec-close.close {
    display: inline-block;
    height: 1.5rem;
    width: 1.5rem;
    box-sizing: content-box;

    &:not(:disabled):not(.disabled) {
        &:hover,
        &:focus {
            opacity: 1;
        }

        &:focus {
            outline: none;
            box-shadow: inset 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
            border-radius: 0.25rem;
        }
    }
}
</style>
